module.exports = __webpack_public_path__ + "img/Syg_icon_tewt.f03946af.png";